import { useState } from 'react';

import { TOrderItem } from '@widgets/OrdersRecognition/model/types';

export const useCurrentOrderId = () => {
    const [currentOrderId, setCurrentOrderId] = useState(null);

    const changeCurrentOrderId = (orderId: TOrderItem['id']) => {
        setCurrentOrderId(orderId);
    };
    const clearCurrentOrderId = () => {
        setCurrentOrderId(null);
    };

    return {
        currentOrderId,
        changeCurrentOrderId,
        clearCurrentOrderId,
    };
};
